import React, { useState } from "react";
import { Form } from "react-bootstrap";
import CheckboxControl from "../InputControls/CheckboxControl";
import { useStateValue } from "../../../store/StateProvider";
import { getSellerCreationErrors, getFieldValidationErrors } from "../../../utils/validator";

const InputCheckbox = ({ fieldConfig, showErrors }) => {
  const [{ hiddenFields, sellerCreationErrors }] = useStateValue();
  const sellerCreationFieldError = getSellerCreationErrors(fieldConfig.id, sellerCreationErrors);
  const [errorMessage, setErrorMessage] = useState(sellerCreationFieldError);
  const [firstLoad, setFirstLoad] = useState(true);

  const labelClass = `input_label_plain ${fieldConfig.labelClass}`;

  const setError = error => {
    setErrorMessage(error);
  };

  const executeFieldValidation = checkboxValue => {
    const error = getFieldValidationErrors(fieldConfig.validators, { [fieldConfig.id]: checkboxValue }, fieldConfig.id);
    setError(error);
  };

  return (
    <Form.Group
      className={`mb3 ${fieldConfig.containerClass} ${hiddenFields.includes(fieldConfig.id) ? "hidden" : ""}`}
      id={`container_${fieldConfig.id}`}
      controlId={fieldConfig.name}>
      <Form.Label className={labelClass}>{fieldConfig.label}</Form.Label>
      <Form.Label className="label_description">{fieldConfig.labelDescription}</Form.Label>
      <CheckboxControl
        fieldConfig={fieldConfig}
        fieldValidator={executeFieldValidation}
        removeErrorMessage={setError.bind(this, null)}
        showErrors={showErrors}
        setFirstLoad={setFirstLoad}
      />
      <Form.Label
        className={`label_error ${!!errorMessage && (!firstLoad || showErrors || sellerCreationFieldError) ? "show" : "hidden"}`}
        id={`label_error_${fieldConfig.id}`}>
        <span id={`label_error_message_${fieldConfig.id}`}>{errorMessage}</span>
      </Form.Label>
    </Form.Group>
  );
};

export default InputCheckbox;
